import { useEffect, useState } from "react"
import Button from "../../../../../ui/molecules/button"
import TextArea from "../../../../../ui/molecules/textArea"
import { ProtocolSearch } from "../../../../../ui/molecules/ProtocolSearch"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { resetCompanyFolderValidationStatus, CompanyFolderCreation, resetSingleCFDetailCreationStatus, GetAllCompanyFolders, setCFDetailCreationRequestDeliveryOnHeadquarter, setCFDetailCreationRequestEntryProtocolId, setCFDetailCreationRequestNote, CompanyFolderValidation } from "../../../../cartellaAziendale/slice"
import { SelectCustom } from "../../../../../ui/molecules/select"

interface Props {
    close: () => void
}

export function AddProtocolNoAttachPopup(props: Props) {
    const dispatch = useAppDispatch()
    const cartellaAziendaleState = useAppSelector(state => state.cartellaAziendale)
    const [protocolType, setProtocolType] = useState<string>('')

    useEffect(() => {
        if (cartellaAziendaleState.companyFolderValidationStatus === 'successfully') {
            dispatch(resetCompanyFolderValidationStatus())
            dispatch(CompanyFolderCreation(cartellaAziendaleState.singleCFDetailCreationRequest))
        }
    }, [cartellaAziendaleState.companyFolderValidationStatus])

    // useEffect(() => {
    //     if(cartellaAziendaleState.singleCFDetailCreationStatus === 'successfully') {
    //         dispatch(resetSingleCFDetailCreationStatus())
    //         dispatch(GetAllCompanyFolders({
    //             customerId: cartellaAziendaleState.getAllCompanyFoldersFilters.customerId,
    //             itemsPerPage: 0,
    //             page: 0
    //         }))
    //         props.close()
    //     }
    // }, [cartellaAziendaleState.singleCFDetailCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>


                <div style={{ flex: '0 0 33.33%' }}>
                    <SelectCustom
                        label="Seleziona Protocollo"
                        placeholder='seleziona'
                        value={protocolType}
                        onChange={(value) => {
                            if (value)
                                setProtocolType(value)
                        }}
                        options={[
                            { value: 'entrata', label: 'Protocollo Entrata' },
                            { value: 'partenza', label: 'Protocollo Partenza' }
                        ]}
                    />
                </div>

                {
                    protocolType === 'entrata' &&
                    <div className="pb-5 mt-4">
                        <ProtocolSearch
                            type='entry'
                            errorLabel={cartellaAziendaleState.singleCFDetailErrors.entryProtocolId ? 'Protocollo mancante' : undefined}
                            onSelect={(value) => {
                                dispatch(setCFDetailCreationRequestEntryProtocolId(value))
                            }} />
                    </div>
                }
                {
                    protocolType === 'partenza' &&
                    <div className="pb-5 mt-4">
                        <ProtocolSearch
                            type='departure'
                            errorLabel={cartellaAziendaleState.singleCFDetailErrors.entryProtocolId ? 'Protocollo mancante' : undefined}
                            onSelect={(value) => {
                                dispatch(setCFDetailCreationRequestEntryProtocolId(value))
                            }} />
                    </div>
                }

                <div className="pb-5">
                    <div className="text-left">
                        <span className="input-label">Note</span>
                    </div>
                    <TextArea
                        onChangeText={(text) => {
                            dispatch(setCFDetailCreationRequestNote(text))
                        }} />
                </div>

            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 10, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            console.log()
                        }}
                    />
                </div>
            </div>
        </div>
    )
}